import { ref, onMounted } from 'vue'

export function useClient () {
  const isClient = ref(false)

  onMounted(() => {
    isClient.value = true
  })

  return { isClient }
}
